export class SoftwareMfaRequired extends Error {
  constructor() {
    super('Software MFA Required.')
    Object.setPrototypeOf(this, SoftwareMfaRequired.prototype)
  }
}
